import NetworkLogic from "../../Shared/NetworkLogic";
import UIManager from "../../Shared/UIManager";
import Utils from "../../Shared/Utils";
import AudioManager from "../../Shared/AudioManager";
import XimaDetails from "./XimaDetails";

const {ccclass, property} = cc._decorator;

@ccclass//洗码记录层
export default class XiMaJiLu extends cc.Component {
    @property(cc.SpriteFrame)
    sp1: cc.SpriteFrame = null;
    @property(cc.SpriteFrame)
    sp2: cc.SpriteFrame = null;
    @property(cc.Node)
    emptyNode: cc.Node = null;
    @property(cc.Node)
    contentNode: cc.Node = null;
    @property(cc.Node)
    itemNode: cc.Node = null;
    // @property(cc.Node)
    // detailNode: cc.Node = null;
    @property(cc.Prefab)
    pfbXimaDetails:cc.Prefab = null;

    bPlayAction = false;

    onLoad () {
        this.emptyNode.active = false;
        this.contentNode.active = false;
        console.log("=====onLoad");

        NetworkLogic.ximaRecord(function (data) {
            UIManager.hideLoadingUI();
            if (!data || data.length <= 0 ){
                this.emptyNode.active = true;
            }else{
                for (let i = 0;i < data.length;i++){
                    let item = cc.instantiate(this.itemNode);
                    item.parent = this.contentNode;
                    item.getChildByName("spBg").getComponent(cc.Sprite).spriteFrame = (i%2 === 0 ? this.sp1 : this.sp2);
                    item.getChildByName("labTime").getComponent(cc.Label).string = data[i].washCodeTime;
                    //item.getChildByName("labName").getComponent(cc.Label).string = "请看详情";
                    item.getChildByName("labTotal").getComponent(cc.Label).string = data[i].washCodeDml.toFixed(2);
                    item.getChildByName("labMoney").getComponent(cc.Label).string = data[i].washCodeMoney.toFixed(2);
                    let btn = item.getChildByName("btnChaKan").getComponent(cc.Button);
                    btn.clickEvents[0].customEventData = data[i].wcdId;//点击详情，暂未实现
                    item.active = true;
                    item.width = item.parent.parent.width;
                }
                this.contentNode.active = true;
                Utils.actionShowContent(this.contentNode);
                this.bPlayAction = true;
            }
            console.log("rich=== Record:",data);
        }.bind(this),function () {
            console.log("rich=== ximaZZXM请求失败")
        })
    }




    onEnable(): void {
        console.log("=====OnEnable");
        if (this.bPlayAction)
            Utils.actionShowContent(this.contentNode);
    }

    start(): void {

    }

    onBtnClick(event,param){
        AudioManager.playSound("button");
        let data = {
            "gameTypeId": 2,
            "wcdId": parseInt(param)
        };
        console.log("====点击详情");

        UIManager.showLoadingUI();
        NetworkLogic.ximaWashCodeDetail(data,function (data) {
            UIManager.hideLoadingUI();
            console.log("====洗码详情 data:",data);
            let pfbXimaDetails = cc.instantiate(this.pfbXimaDetails);
            pfbXimaDetails.parent = this.node.parent.parent;
            pfbXimaDetails.active = true;
            let details = pfbXimaDetails.getComponent("XimaDetails");
            details.data = data;
            //this.detailNode.active = true;
        }.bind(this),function () {
            console.log("===洗码记录失败")
        }.bind(this))

    }
}
